import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { Container, Grid, Paper, Stack, Typography, TextField as MuiTextField, Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, getISTDate, getMonthYear, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { STOCK_STATUS_REPORT } from '../../../../../constants/dropdown';
import { SelectDoctorTable } from '../../HMS/masters/others/SelectDoctorTable';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';


export const StockStatusReport = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [input, setInput] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [location, setLocation] = useState([]);
  const [product, setProduct] = useState([]);
  const [stockDetails, setStockDetails] = useState([]);
  const [group, setGroup] = useState([]);
  const [subGroup, setSubGroup] = useState([]);
  const [category, setCategory] = useState([]);
  const [salt, setSalt] = useState([]);
  const [productids, setProductIds] = useState('');
  const [grouptids, setGroupIds] = useState('');
  const [subgroupids, setSubgroupids] = useState('');
  const [categoryIds, setCategoryIds] = useState('');
  const [saltIds, setSaltIds] = useState('');

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: getISTDate()
    },
    mode: 'all'
  });

  const { watch, setValue } = methods;

  const PRODUCT_HEADER = [{ header: 'Product Name', accessor: (row) => row?.main?.name }].filter(Boolean);
  const GROUP_HEADER = [{ header: 'Group Name', accessor: (row) => row?.group_name }].filter(Boolean);
  const SUBGROUP_HEADER = [{ header: 'SubGroup Name', accessor: (row) => row?.sub_group }].filter(Boolean);
  const CATEGORY_HEADER = [{ header: 'Category Name', accessor: (row) => row?.category_name }].filter(Boolean);
  const SALT_HEADER = [{ header: 'Salt Name', accessor: (row) => row?.generic_name }].filter(Boolean);

  const BILL_TABLE_HEADER = [
    {
      header: 'Product Name',
      accessor: (row) => row?.productInfo?.main?.name
    },
    { header: 'Batch No', accessor: (row) => row?.batch_no },
    { header: 'Exp Date', accessor: (row) => getMonthYear(row?.exp_date) },
    { header: 'InQty', accessor: (row) => row?.totalInQty || 0 },
    { header: 'outQty', accessor: (row) => row?.totalOutQty || 0 },
    { header: 'Balance', accessor: (row) => row?.totalStock || 0 },
    { header: 'Rate', accessor: 'rate' },
    { header: 'MRP', accessor: 'mrp' },
    { header: 'Stock Value', accessor: 'stockValue' }
  ].filter(Boolean);

  const isSelected = (row, field) => {
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      return false;
    }
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      setSelectedRows([]);
      return;
    }
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);
      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow._id === row._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  useEffect(() => {
    const totalBillQty = selectedRows.reduce((acc, item) => acc + item.bill_qty, 0);
    setValue('bill_qty', totalBillQty);
  }, [selectedRows]);

  const getWarehouseDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    const [defaultState] = data.filter(({ status }) => status === 'default');
    setValue('location', defaultState?._id);
    setLocation(data);
  }, []);

  useEffect(() => {
    getWarehouseDropdown();
  }, [getWarehouseDropdown]);

  const limit = 10;
  const filterBy = watch('filter_by');
  const watchLocation = watch('location');
  useEffect(() => {
    setSelectedRows([]);
  }, [filterBy]);


  const getProductDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/product-master/dropdown?limit=${limit}`);
    setProduct(response.data);
  }, []);

  const getGroupDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/pharmacy-group/dropdown?limit=${limit}`);
    setGroup(response.data);
  }, []);

  const getSubGroupDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/pharmacy-subgroup/dropdown?limit=${limit}`);
    setSubGroup(response.data);
  }, []);

  const getCategoryDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/product-category/dropdown?limit=${limit}`);
    setCategory(response.data);
  }, []);

  const getSaltDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/generic-master/dropdown?limit=${limit}`);
    setSalt(response.data);
  }, []);

  const searchProducts = useCallback(async () => {
    const lowercasedInput = String(input).toLowerCase();
    const response = await axios.get(`${BASE_URL}/product-master/dropdown?name=${lowercasedInput}&limit=${limit}`);
    setProduct(response.data);
  }, [input]);

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  useEffect(() => {
    if (filterBy === 'PRODUCT NAME') {
      getProductDropdown();
    }
  }, [filterBy, getProductDropdown]);

  useEffect(() => {
    if (filterBy === 'GROUP') {
      getGroupDropdown();
    }
  }, [filterBy, getGroupDropdown]);

  useEffect(() => {
    if (filterBy === 'SUBGROUP') {
      getSubGroupDropdown();
    }
  }, [filterBy, getSubGroupDropdown]);

  useEffect(() => {
    if (filterBy === 'CATEGORY NAME') {
      getCategoryDropdown();
    }
  }, [filterBy, getCategoryDropdown]);

  useEffect(() => {
    if (filterBy === 'SALT NAME') {
      getSaltDropdown();
    }
  }, [filterBy, getSaltDropdown]);

  useEffect(() => {
    if (filterBy === 'PRODUCT NAME') {
      searchProducts();
    }
  }, [filterBy, input, searchProducts]);

  const fetchProductStockData = async () => {
    if (selectedRows.length === 0) {
      toast('Select Any Item First', { variant: 'warning' });
      return;
    }
    const ids = selectedRows.map((item) => item._id).join(',');
    setProductIds(ids);
    const response = await axios.get(`${BASE_URL}/stock-master-multiple-product?name=${ids}&location=${watchLocation}`);
    setStockDetails(response.data);
  };

  const fetchProductStockDataByGroup = async () => {
    if (selectedRows.length === 0) {
      toast('Select Any Product First', { variant: 'warning' });
      return;
    }
    const ids = selectedRows.map((item) => item._id).join(',');
    setGroupIds(ids);
    const response = await axios.get(
      `${BASE_URL}/stock-master-multiple-product-group?group=${ids}&location=${watchLocation}`
    );
    setStockDetails(response.data);
  };

  const fetchProductStockDataBySubGroup = async () => {
    if (selectedRows.length === 0) {
      toast('Select Any Product First', { variant: 'warning' });
      return;
    }
    const ids = selectedRows.map((item) => item._id).join(',');
    setSubgroupids(ids);
    const response = await axios.get(
      `${BASE_URL}/stock-master-multiple-product-subgroup?subgroup=${ids}&location=${watchLocation}`
    );
    setStockDetails(response.data);
  };

  const fetchProductStockDataByCategory = async () => {
    if (selectedRows.length === 0) {
      toast('Select Any Product First', { variant: 'warning' });
      return;
    }
    const ids = selectedRows.map((item) => item._id).join(',');
    setCategoryIds(ids);
    const response = await axios.get(
      `${BASE_URL}/stock-master-multiple-product-category?category=${ids}&location=${watchLocation}`
    );
    setStockDetails(response.data);
  };

  const fetchProductStockDataBySalt = async () => {
    if (selectedRows.length === 0) {
      toast('Select Any Product First', { variant: 'warning' });
      return;
    }
    const ids = selectedRows.map((item) => item._id).join(',');
    setSaltIds(ids);
    const response = await axios.get(
      `${BASE_URL}/stock-master-multiple-product-salt?salt=${ids}&location=${watchLocation}`
    );
    setStockDetails(response.data);
  };

  const handleExcelReportByProduct = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    try {
      const ids = selectedRows.map((item) => item._id).join(',');
      if (ids.length === 0) {
        toast('Please Select Any Item First', { variant: 'warning' });
        return;
      }
      const response = await axios.get(
        `${BASE_URL}/stock-master-multiple-product?name=${ids}&location=${watchLocation}`
      );
      if (response.data.success) {
        const stockData = response?.data?.data;

        if (stockData && stockData.length > 0) {
          const formattedStockData = stockData.map((item, index) => {
            const productName = item?.productInfo?.main?.name || '';
            const batchNo = item?.batch_no || '';
            const expDate = item?.exp_date ? new Date(item.exp_date).toLocaleDateString() : '';
            const inQty = item?.totalInQty ?? 0;
            const outQty = item?.totalOutQty ?? 0;
            const balance = item?.totalStock ?? 0;
            const rate = item?.productInfo?.purchase_rate ?? 0;
            const mrp = item?.mrp ?? 0;
            const stockValue = item?.stockValue ?? rate * balance;
            return {
              'Sr. No.': index + 1,
              'Product Name': productName,
              'Batch No': batchNo,
              'Exp Date': expDate,
              InQty: inQty,
              OutQty: outQty,
              Balance: balance,
              Rate: rate,
              MRP: mrp,
              'Stock Value': stockValue
            };
          });

          const fileName = `Stock_Report_${new Date().toISOString().split('T')[0]}`;

          // Create worksheet and set column widths
          const ws = XLSX.utils.json_to_sheet(formattedStockData);
          ws['!cols'] = [
            { wch: 6 }, // Sr. No.
            { wch: 30 }, // Product Name
            { wch: 15 }, // Batch No
            { wch: 15 }, // Exp Date
            { wch: 10 }, // InQty
            { wch: 10 }, // OutQty
            { wch: 10 }, // Balance
            { wch: 10 }, // Rate
            { wch: 10 }, // MRP
            { wch: 15 } // Stock Value
          ];

          // Create the workbook and export
          const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
          const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
          const data = new Blob([excelBuffer], { type: fileType });

          saveAs(data, fileName + fileExtension);
        } else {
          toast('No Stock Data Found', { variant: 'error' });
        }
      } else {
        toast('Something Went Wrong', { variant: 'error' });
      }
    } catch (error) {
      console.error('Excel Export Error:', error);
      toast('Failed to Export Excel', { variant: 'error' });
    }
  };

  const handleExcelReportByGroup = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    try {
      const ids = selectedRows.map((item) => item._id).join(',');
      if (ids.length === 0) {
        toast('Please Select Any Item First', { variant: 'warning' });
        return;
      }
      const response = await axios.get(
        `${BASE_URL}/stock-master-multiple-product-group?group=${ids}&location=${watchLocation}`
      );
      if (response.data.success) {
        const stockData = response?.data?.data;

        if (stockData && stockData.length > 0) {
          const formattedStockData = stockData.map((item, index) => {
            const productName = item?.productInfo?.main?.name || '';
            const batchNo = item?.batch_no || '';
            const expDate = item?.exp_date ? new Date(item.exp_date).toLocaleDateString() : '';
            const inQty = item?.totalInQty ?? 0;
            const outQty = item?.totalOutQty ?? 0;
            const balance = item?.totalStock ?? 0;
            const rate = item?.productInfo?.purchase_rate ?? 0;
            const mrp = item?.mrp ?? 0;
            const stockValue = item?.stockValue ?? rate * balance;

            return {
              'Sr. No.': index + 1,
              'Product Name': productName,
              'Batch No': batchNo,
              'Exp Date': expDate,
              InQty: inQty,
              OutQty: outQty,
              Balance: balance,
              Rate: rate,
              MRP: mrp,
              'Stock Value': stockValue
            };
          });
          const fileName = `Stock_Report_${new Date().toISOString().split('T')[0]}`;
          const ws = XLSX.utils.json_to_sheet(formattedStockData);
          ws['!cols'] = [
            { wch: 6 },
            { wch: 30 },
            { wch: 15 },
            { wch: 15 },
            { wch: 10 },
            { wch: 10 }, // OutQty
            { wch: 10 }, // Balance
            { wch: 10 }, // Rate
            { wch: 10 }, // MRP
            { wch: 15 } // Stock Value
          ];
          const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
          const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
          const data = new Blob([excelBuffer], { type: fileType });
          saveAs(data, fileName + fileExtension);
        } else {
          toast('No Stock Data Found', { variant: 'error' });
        }
      } else {
        toast('Something Went Wrong', { variant: 'error' });
      }
    } catch (error) {
      console.error('Excel Export Error:', error);
      toast('Failed to Export Excel', { variant: 'error' });
    }
  };

  const handleExcelReportBySubGroup = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    try {
      const ids = selectedRows.map((item) => item._id).join(',');
      if (ids.length === 0) {
        toast('Please Select Any Item First', { variant: 'warning' });
        return;
      }
      const response = await axios.get(
        `${BASE_URL}/stock-master-multiple-product-subgroup?subgroup=${ids}&location=${watchLocation}`
      );
      if (response.data.success) {
        const stockData = response?.data?.data;
        if (stockData && stockData.length > 0) {
          const formattedStockData = stockData.map((item, index) => {
            const productName = item?.productInfo?.main?.name || '';
            const batchNo = item?.batch_no || '';
            const expDate = item?.exp_date ? new Date(item.exp_date).toLocaleDateString() : '';
            const inQty = item?.totalInQty ?? 0;
            const outQty = item?.totalOutQty ?? 0;
            const balance = item?.totalStock ?? 0;
            const rate = item?.productInfo?.purchase_rate ?? 0;
            const mrp = item?.mrp ?? 0;
            const stockValue = item?.stockValue ?? rate * balance;
            return {
              'Sr. No.': index + 1,
              'Product Name': productName,
              'Batch No': batchNo,
              'Exp Date': expDate,
              InQty: inQty,
              OutQty: outQty,
              Balance: balance,
              Rate: rate,
              MRP: mrp,
              'Stock Value': stockValue
            };
          });
          const fileName = `Stock_Report_${new Date().toISOString().split('T')[0]}`;
          const ws = XLSX.utils.json_to_sheet(formattedStockData);
          ws['!cols'] = [
            { wch: 6 }, // Sr. No.
            { wch: 30 }, // Product Name
            { wch: 15 }, // Batch No
            { wch: 15 }, // Exp Date
            { wch: 10 }, // InQty
            { wch: 10 }, // OutQty
            { wch: 10 }, // Balance
            { wch: 10 }, // Rate
            { wch: 10 }, // MRP
            { wch: 15 } // Stock Value
          ];
          const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
          const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
          const data = new Blob([excelBuffer], { type: fileType });
          saveAs(data, fileName + fileExtension);
        } else {
          toast('No Stock Data Found', { variant: 'error' });
        }
      } else {
        toast('Something Went Wrong', { variant: 'error' });
      }
    } catch (error) {
      console.error('Excel Export Error:', error);
      toast('Failed to Export Excel', { variant: 'error' });
    }
  };

  const handleExcelReportByCategory = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    try {
      const ids = selectedRows.map((item) => item._id).join(',');
      if (ids.length === 0) {
        toast('Please Select Any Item First', { variant: 'warning' });
        return;
      }
      const response = await axios.get(
        `${BASE_URL}/stock-master-multiple-product-category?category=${ids}&location=${watchLocation}`
      );
      if (response.data.success) {
        const stockData = response?.data?.data;

        if (stockData && stockData.length > 0) {
          const formattedStockData = stockData.map((item, index) => {
            const productName = item?.productInfo?.main?.name || '';
            const batchNo = item?.batch_no || '';
            const expDate = item?.exp_date ? new Date(item.exp_date).toLocaleDateString() : '';
            const inQty = item?.totalInQty ?? 0;
            const outQty = item?.totalOutQty ?? 0;
            const balance = item?.totalStock ?? 0;
            const rate = item?.productInfo?.purchase_rate ?? 0;
            const mrp = item?.mrp ?? 0;
            const stockValue = item?.stockValue ?? rate * balance;
            return {
              'Sr. No.': index + 1,
              'Product Name': productName,
              'Batch No': batchNo,
              'Exp Date': expDate,
              InQty: inQty,
              OutQty: outQty,
              Balance: balance,
              Rate: rate,
              MRP: mrp,
              'Stock Value': stockValue
            };
          });

          const fileName = `Stock_Report_${new Date().toISOString().split('T')[0]}`;

          // Create worksheet and set column widths
          const ws = XLSX.utils.json_to_sheet(formattedStockData);
          ws['!cols'] = [
            { wch: 6 }, // Sr. No.
            { wch: 30 }, // Product Name
            { wch: 15 }, // Batch No
            { wch: 15 }, // Exp Date
            { wch: 10 }, // InQty
            { wch: 10 }, // OutQty
            { wch: 10 }, // Balance
            { wch: 10 }, // Rate
            { wch: 10 }, // MRP
            { wch: 15 } // Stock Value
          ];

          // Create the workbook and export
          const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
          const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
          const data = new Blob([excelBuffer], { type: fileType });

          saveAs(data, fileName + fileExtension);
        } else {
          toast('No Stock Data Found', { variant: 'error' });
        }
      } else {
        toast('Something Went Wrong', { variant: 'error' });
      }
    } catch (error) {
      console.error('Excel Export Error:', error);
      toast('Failed to Export Excel', { variant: 'error' });
    }
  };

  const handleExcelReportBySalt = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    try {
      const ids = selectedRows.map((item) => item._id).join(',');
      if (ids.length === 0) {
        toast('Please Select Any Item First', { variant: 'warning' });
        return;
      }
      const response = await axios.get(
        `${BASE_URL}/stock-master-multiple-product-salt?salt=${ids}&location=${watchLocation}`
      );
      if (response.data.success) {
        const stockData = response?.data?.data;

        if (stockData && stockData.length > 0) {
          const formattedStockData = stockData.map((item, index) => {
            const productName = item?.productInfo?.main?.name || '';
            const batchNo = item?.batch_no || '';
            const expDate = item?.exp_date ? new Date(item.exp_date).toLocaleDateString() : '';
            const inQty = item?.totalInQty ?? 0;
            const outQty = item?.totalOutQty ?? 0;
            const balance = item?.totalStock ?? 0;
            const rate = item?.productInfo?.purchase_rate ?? 0;
            const mrp = item?.mrp ?? 0;
            const stockValue = item?.stockValue ?? rate * balance;

            return {
              'Sr. No.': index + 1,
              'Product Name': productName,
              'Batch No': batchNo,
              'Exp Date': expDate,
              InQty: inQty,
              OutQty: outQty,
              Balance: balance,
              Rate: rate,
              MRP: mrp,
              'Stock Value': stockValue
            };
          });

          const fileName = `Stock_Report_${new Date().toISOString().split('T')[0]}`;

          // Create worksheet and set column widths
          const ws = XLSX.utils.json_to_sheet(formattedStockData);
          ws['!cols'] = [
            { wch: 6 }, // Sr. No.
            { wch: 30 }, // Product Name
            { wch: 15 }, // Batch No
            { wch: 15 }, // Exp Date
            { wch: 10 }, // InQty
            { wch: 10 }, // OutQty
            { wch: 10 }, // Balance
            { wch: 10 }, // Rate
            { wch: 10 }, // MRP
            { wch: 15 } // Stock Value
          ];

          // Create the workbook and export
          const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
          const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
          const data = new Blob([excelBuffer], { type: fileType });

          saveAs(data, fileName + fileExtension);
        } else {
          toast('No Stock Data Found', { variant: 'error' });
        }
      } else {
        toast('Something Went Wrong', { variant: 'error' });
      }
    } catch (error) {
      console.error('Excel Export Error:', error);
      toast('Failed to Export Excel', { variant: 'error' });
    }
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Stock Status
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  onClick={
                    filterBy === 'PRODUCT NAME'
                      ? fetchProductStockData
                      : filterBy === 'GROUP'
                        ? fetchProductStockDataByGroup
                        : filterBy === 'SUBGROUP'
                          ? fetchProductStockDataBySubGroup
                          : filterBy === 'CATEGORY NAME'
                            ? fetchProductStockDataByCategory
                            : filterBy === 'SALT NAME'
                              ? fetchProductStockDataBySalt
                              : null
                  }
                >
                  View
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  onClick={
                    filterBy === 'PRODUCT NAME'
                      ? handleExcelReportByProduct
                      : filterBy === 'GROUP'
                        ? handleExcelReportByGroup
                        : filterBy === 'SUBGROUP'
                          ? handleExcelReportBySubGroup
                          : filterBy === 'CATEGORY NAME'
                            ? handleExcelReportByCategory
                            : filterBy === 'SALT NAME'
                              ? handleExcelReportBySalt
                              : null
                  }
                >
                  Export Excel
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => {
                    if (filterBy === 'PRODUCT NAME') {
                      const refId = JSON.stringify({ name: productids, location: watchLocation });
                      window.open(`/print${pathname}?refId=${refId}`, '_blank');
                    } else if (filterBy === 'GROUP') {
                      const refId = JSON.stringify({ group: grouptids, location: watchLocation });
                      window.open(`/print${pathname}/group?refId=${refId}`, '_blank');
                    } else if (filterBy === 'SUBGROUP') {
                      const refId = JSON.stringify({ sub_group: subgroupids, location: watchLocation });
                      window.open(`/print${pathname}/subgroup?refId=${refId}`, '_blank');
                    } else if (filterBy === 'CATEGORY NAME') {
                      const refId = JSON.stringify({ category: categoryIds, location: watchLocation });
                      window.open(`/print${pathname}/category?refId=${refId}`, '_blank');
                    } else {
                      const refId = JSON.stringify({ salt: saltIds, location: watchLocation });
                      window.open(`/print${pathname}/salt?refId=${refId}`, '_blank');
                    }
                  }}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Write`} variant="contained">
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                border: '1px solid lightgray'
              }}
            >
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Filter By</Typography>
                  <SelectTag formControlSX={{ flex: 0.8 }} name="filter_by" menus={STOCK_STATUS_REPORT} />
                </Stack>
                <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    name="location"
                    menus={location.map((data) => ({ ...data, name: data.warehouse_name }))}
                  />
                </Stack>
              </Stack>
            </Box>
            <Grid container spacing={2} sx={{ marginTop: '2%' }}>
              <Grid item xs={5} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {filterBy === 'PRODUCT NAME' && (
                  <MuiTextField
                    sx={{
                      width: '100%',
                      '& .MuiOutlinedInput-root': {
                        padding: '0',
                        fontSize: '1.4rem'
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '8px 1.4rem'
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '1.2rem'
                      }
                    }}
                    label="Search By Product Name"
                    variant="outlined"
                    value={input}
                    onChange={handleChange}
                  />
                )}

                {filterBy === 'PRODUCT NAME' && (
                  <SelectDoctorTable
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={product.data || []}
                    columns={PRODUCT_HEADER}
                    size="small"
                    showInputField={true}
                    showOk={true}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    currentAction={'new'}
                    selectedRows={selectedRows}
                  />
                )}

                {filterBy === 'GROUP' && (
                  <SelectDoctorTable
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={group.data || []}
                    columns={GROUP_HEADER}
                    size="small"
                    showInputField={true}
                    showOk={true}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    currentAction={'new'}
                    selectedRows={selectedRows}
                  />
                )}

                {filterBy === 'SUBGROUP' && (
                  <SelectDoctorTable
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={subGroup.data || []}
                    columns={SUBGROUP_HEADER}
                    size="small"
                    showInputField={true}
                    showOk={true}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    currentAction={'new'}
                    selectedRows={selectedRows}
                  />
                )}

                {filterBy === 'CATEGORY NAME' && (
                  <SelectDoctorTable
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={category.data || []}
                    columns={CATEGORY_HEADER}
                    size="small"
                    showInputField={true}
                    showOk={true}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    currentAction={'new'}
                    selectedRows={selectedRows}
                  />
                )}

                {filterBy === 'SALT NAME' && (
                  <SelectDoctorTable
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={salt.data || []}
                    columns={SALT_HEADER}
                    size="small"
                    showInputField={true}
                    showOk={true}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    currentAction={'new'}
                    selectedRows={selectedRows}
                  />
                )}
              </Grid>

              {filterBy && (
                <Grid item xs={7} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <SelectDoctorTable
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={stockDetails.data || []}
                    columns={BILL_TABLE_HEADER}
                    size="small"
                    showInputField={true}
                  />
                </Grid>
              )}
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
